import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
//  Interface for Data table data type for all the columns
export interface Props {
  children?: FC;
  item?: AccountEventName;
}

interface AccountEventName {
  surgeon?: string;
}
const OrderSurgeonName: FC<Props> = ({
  item = {
    surgeon: '',
  },
}) => {
  const { surgeon } = item;
  return (
    <DataTableCell title={surgeon || ''}>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{surgeon}</p>
    </DataTableCell>
  );
};

/** Custom Account/Event Name cell */
export default OrderSurgeonName;
